import(/* webpackMode: "eager" */ "/Users/brucefury/Projects/Atomic/ali-lms/lms-frontend/app/page.tsx");
